import React, { useState } from 'react';
import { TextField, Button, Box, CircularProgress } from '@mui/material';
import PrivacyConsent from './PrivacyConsent';

const SceneInput = ({ onSubmit, loading, onPrivacyChange }) => {
  const [scene, setScene] = useState('');
  const [summary, setSummary] = useState('');
  const [objectives, setObjectives] = useState('');
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (privacyAccepted) {
      onSubmit(scene, summary, objectives);
    }
  };

  const handlePrivacyChange = (e) => {
    setPrivacyAccepted(e.target.checked);
    onPrivacyChange(e.target.checked);
  };

  const handleKeyDown = (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter' && privacyAccepted) {
      e.preventDefault();
      onSubmit(scene, summary, objectives);
    }
  };

  const buttonText = 'Analyze Scene';

  const textFieldSx = {
    mb: '1rem',
    '& .MuiInputBase-root': {
      minHeight: '8rem',
      resize: 'vertical',
      display: 'flex',
      backdropFilter: 'blur(5px)',
      backgroundColor: 'rgba(18, 18, 18, 0.4)',
      '&:hover': {
        cursor: 'ns-resize'
      },
      '& fieldset': {
        borderColor: '#f94c57',
      },
      '&:hover fieldset': {
        borderColor: '#d32f2f',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#d32f2f',
      }
    },
    '& .MuiInputBase-input': {
      flex: 1,
      height: '100% !important',
      overflow: 'auto !important'
    },
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: '#f94c57'
      }
    }
  };

  const summaryFieldSx = {
    mb: '1rem',
    '& .MuiInputBase-root': {
      minHeight: '4rem',
      resize: 'vertical',
      display: 'flex',
      backdropFilter: 'blur(5px)',
      backgroundColor: 'rgba(18, 18, 18, 0.4)',
      '&:hover': {
        cursor: 'ns-resize'
      },
      '& fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.23)',
      },
      '&:hover fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.87)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(255, 255, 255, 0.87)',
      }
    },
    '& .MuiInputBase-input': {
      flex: 1,
      height: '100% !important',
      overflow: 'auto !important'
    },
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: 'rgba(255, 255, 255, 0.87)'
      }
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <TextField
        fullWidth
        required
        multiline
        rows={4}
        label="Scene"
        value={scene}
        onChange={(e) => setScene(e.target.value)}
        placeholder="Paste your scene here..."
        sx={textFieldSx}
        inputProps={{
          style: { resize: 'none', minHeight: 'inherit' }
        }}
        onKeyDown={handleKeyDown}
      />
      <TextField
        fullWidth
        multiline
        rows={2}
        label="Story Summary (Optional)"
        value={summary}
        onChange={(e) => setSummary(e.target.value)}
        placeholder="Brief summary of the story..."
        sx={summaryFieldSx}
        inputProps={{
          style: { resize: 'none', minHeight: 'inherit' }
        }}
        onKeyDown={handleKeyDown}
      />
      <TextField
        fullWidth
        multiline
        rows={2}
        label="Character Objectives (Optional)"
        value={objectives}
        onChange={(e) => setObjectives(e.target.value)}
        placeholder="Known character objectives..."
        sx={summaryFieldSx}
        inputProps={{
          style: { resize: 'none', minHeight: 'inherit' }
        }}
        onKeyDown={handleKeyDown}
      />
      <PrivacyConsent
        checked={privacyAccepted}
        onChange={handlePrivacyChange}
      />
      <Button
        fullWidth
        type="submit"
        variant="contained"
        disabled={loading || !scene.trim() || !privacyAccepted}
        sx={{ 
          mt: '1rem',
          textTransform: 'none'
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={20} />
            <span>Analyzing... (10-15 seconds)</span>
          </Box>
        ) : buttonText}
      </Button>
    </Box>
  );
};

export default SceneInput;
